import { useAppSelector } from 'flow/hooks/useRedux';
import { getIsSinglePaneMode } from 'flow/selectors/selectors';
import TicketBackButton from './TicketHeader/TicketBackButton';
import TicketAccessMissing from './TicketAccessMissing';

/**
 * The missing-access state as a page. A ticket the user may not read has no
 * header, and in single-pane mode that header carries the only way back to the
 * list — so the bar stays, holding the back button alone.
 *
 * The popover shows `TicketAccessMissing` on its own, since a dialog closes by
 * its own controls and a back button there would navigate the page behind it.
 */
const TicketAccessMissingPage = () => {
    const isSinglePaneMode = useAppSelector(getIsSinglePaneMode);

    if (!isSinglePaneMode) return <TicketAccessMissing />;

    return (
        <div className="flex h-full w-full flex-col">
            {/* Same height as the ticket's own header bar, so the state sits
                where the ticket did. */}
            <div className="flex h-16 shrink-0 items-center px-4">
                <TicketBackButton />
            </div>
            <div className="min-h-0 grow">
                <TicketAccessMissing />
            </div>
        </div>
    );
};

export default TicketAccessMissingPage;
